import {Label} from "@/components/ui/label";
import {Textarea} from "@/components/ui/textarea";
import {useState} from "react";
import {Button} from "@/components/ui/button";
import toast from "react-hot-toast";
import useCreateNotice from "@/query/alarm/useCreateNotice";
import {useDialog} from "@/hook/useDialog";

export const NoticeTextArea = () => {
    const dialog = useDialog();
    const [notice, setNotice] = useState("");

    const {mutateAsync: sendNotice} = useCreateNotice();

    const onSubmit = async () => {
        if(!notice) {
            toast.error("공지는 필수 작성란 입니다.");
            return;
        }

        dialog.open({
            variant: "danger",
            title: "공지 알림 발송",
            content: "모든 워크스페이스에 공지 알림을 발송합니다.",
            onConfirm: async () => {
                try {
                    await sendNotice({ notice: notice })
                    toast.success("공지 생성 성공")
                    setNotice("")
                } catch (e) {
                    toast.error("에러 발생 !!! 공지 생성 실패")
                }
            }
        })
    }

    return (
        <div className="flex flex-col gap-3">
            <Label htmlFor="notice">Notice</Label>
            <Textarea value={notice}
                      onChange={(e) => setNotice(e.target.value)}
                      placeholder="Input Notice"
                      rows={10}

            />
            <div className="flex justify-end">
                <Button onClick={onSubmit}>
                    Send
                </Button>
            </div>
        </div>
    )
}

export default NoticeTextArea;